/** No account control: the demo path, and the e2e test-token path under a real base URL. */
import { RouterProvider } from 'react-router-dom'
import { ConsoleChrome } from './components/chrome/ConsoleChrome'
import { buildRouter } from './console-router.ts'

export function PlainConsole() {
  const router = buildRouter((children) => <ConsoleChrome>{children}</ConsoleChrome>)
  return <RouterProvider router={router} />
}
